import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const PickerTriggerButton = styled(Button)(({ theme }) => ({
  height: 32,
  borderRadius: 10,
  paddingLeft: 12,
  paddingRight: 12,
  fontSize: '0.75rem',
  lineHeight: 1,
  fontWeight: 600,
  textTransform: 'none',
  color: theme.palette.primary.dark,
  backgroundColor: '#fff',
  boxShadow: '0 4px 14px -4px rgba(47, 39, 117, 0.25)',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.92)',
  },
  '& .MuiButton-startIcon': {
    marginRight: 6,
    marginLeft: 0,
    alignItems: 'center',
  },
  '& .MuiButton-startIcon > svg': {
    width: 14,
    height: 14,
  },
}));

export const PickerPopper = styled(Popper)({
  zIndex: 1300,
  width: 320,
});

export const PickerPaper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 14,
  boxShadow: '0 24px 64px rgba(15, 23, 42, 0.16)',
  padding: theme.spacing(1),
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

export const SectionLabelBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.6875rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.disabled,
}));

export const LoadingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const EmptyText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

export const MemberMenuList = styled(MenuList)({
  maxHeight: 260,
  overflowY: 'auto',
  paddingTop: 0,
  paddingBottom: 0,
});

export const MemberMenuItem = styled(MenuItem)(({ theme }) => ({
  gap: theme.spacing(1),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
}));

export const PendingSpinner = styled(CircularProgress)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
}));

export const MemberAvatar = styled(Avatar)({
  width: 28,
  height: 28,
  fontSize: 12,
});

export const MemberInfoBox = styled(Box)({
  flex: 1,
  minWidth: 0,
});
